import { useTranslation } from "react-i18next";

const IMG = "https://images.pexels.com/photos/60611/vaulted-cellar-tunnel-arches-keller-60611.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function AboutPage() {
  const { t } = useTranslation();
  const values = [
    { n: "01", t: t("about.v1_t"), d: t("about.v1_d") },
    { n: "02", t: t("about.v2_t"), d: t("about.v2_d") },
    { n: "03", t: t("about.v3_t"), d: t("about.v3_d") },
  ];

  return (
    <>
      <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-20 pb-14">
        <div className="text-xs font-mono uppercase tracking-[0.25em] text-amber-400/80 mb-3">
          {t("about.kicker")}
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif font-bold tracking-tight max-w-4xl">
          {t("about.title")}
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24 grid md:grid-cols-2 gap-14 items-start">
        <div className="space-y-6 text-slate-300 leading-relaxed">
          <p>{t("about.p1")}</p>
          <p>{t("about.p2")}</p>
          <p>{t("about.p3")}</p>
        </div>
        <div>
          <img src={IMG} alt="" className="rounded-2xl border border-amber-500/25 shadow-2xl shadow-black/40" />
        </div>
      </section>

      <section className="border-y border-amber-500/15 bg-[#0F1C3F]/40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-10">
          {values.map((v) => (
            <div key={v.n}>
              <div className="font-mono text-amber-400 text-sm mb-3">{v.n}</div>
              <h3 className="font-serif text-2xl mb-3">{v.t}</h3>
              <p className="text-slate-400 leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
